export default __webpack_public_path__ + "img/fhqLuBul.a29612b4.svg";